import OutageTakeover from '../components/OutageTakeover'

// /broken — always renders the outage takeover regardless of network state.
// This is the shareable link: post it anywhere, anyone who opens it sees
// the full unhinged experience even when everything is actually working.
export default function Broken() {
  return <OutageTakeover forceShow />
}
